// Single source of truth for the plans shown on the Landing Page and Checkout Page.
// Keep prices in sync with the server-side PLANS map in routes/index.js, which is
// the authority actually used when charging a card.
export const PRICING_PLANS = {
  starter: {
    id: "starter",
    name: "Starter",
    pricing: { mo: 9, yr: 99 },
    tagline: "For small, independent tailors.",
    features: [
      "Up to 500 customers",
      "Basic order tracking",
      "Standard inventory",
      "Email support",
    ],
  },
  professional: {
    id: "professional",
    name: "Professional",
    pricing: { mo: 19, yr: 199 },
    tagline: "For growing tailor businesses.",
    highlight: true,
    features: [
      "Unlimited customers",
      "Advanced order tracking",
      "Full financial suite",
      "Employee management",
      "Priority support",
    ],
  },
};

// How much a plan saves per year when paid yearly instead of monthly.
export function annualSavings(plan) {
  return plan.pricing.mo * 12 - plan.pricing.yr;
}